module.exports = __webpack_public_path__ + "img/CALOGERO_15s.c82a6478.jpg";